import React from "react";
import LegalShell from "../../components/LegalShell";

export default function Dmca() {
    return (
        <LegalShell title="DMCA & Copyright Policy" tagline="Digital Millennium Copyright Act takedown procedure." testId="page-dmca">
            <p>footsie respects the intellectual property of others and expects users to do the same. We respond to notices of alleged copyright infringement that comply with the Digital Millennium Copyright Act, 17 U.S.C. § 512.</p>

            <h2 className="display text-xl font-black">Submit a takedown notice</h2>
            <p>To file a notice, send an email to our designated agent that includes:</p>
            <ol className="list-decimal pl-5 space-y-1">
                <li>Your physical or electronic signature.</li>
                <li>Identification of the copyrighted work claimed to be infringed.</li>
                <li>The URL(s) of the infringing content on footsie.</li>
                <li>Your contact information (name, address, phone, email).</li>
                <li>A statement that you have a good-faith belief that the use is not authorised.</li>
                <li>A statement, under penalty of perjury, that the information is accurate and you are authorised to act.</li>
            </ol>

            <h2 className="display text-xl font-black">Designated agent</h2>
            <address className="not-italic bg-[#FFFDF7] brut-inset rounded-lg p-3 text-sm">
                DMCA Agent — footsie<br />
                <a href="mailto:dmca@feetrate.app" className="underline">dmca@feetrate.app</a>
            </address>

            <h2 className="display text-xl font-black">Counter-notice</h2>
            <p>If you believe your content was removed by mistake or misidentification, you may file a counter-notice under 17 U.S.C. § 512(g). Include your signature, identification of the removed content, a statement under penalty of perjury of good-faith belief that the removal was in error, your contact information, and your consent to the jurisdiction of the U.S. District Court for the District of Delaware.</p>

            <h2 className="display text-xl font-black">Repeat infringers</h2>
            <p>Accounts of users who repeatedly infringe copyright will be terminated in accordance with 17 U.S.C. § 512(i).</p>

            <h2 className="display text-xl font-black">Misrepresentation</h2>
            <p>Under 17 U.S.C. § 512(f), any person who knowingly materially misrepresents that content is infringing (or was removed by mistake) may be liable for damages.</p>
        </LegalShell>
    );
}
